export const TOUR_LS_PREFIX = 'tour:dismissed:'
